export const money = (n: number, c: string) => {
  if (!Number.isSafeInteger(n)) {
    return `${(n / 100).toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${c}`;
  }
  const minor = BigInt(n);
  const absolute = minor < 0n ? -minor : minor;
  const major = absolute / 100n;
  const cents = (absolute % 100n).toString().padStart(2, "0");
  return `${minor < 0n ? "-" : ""}${major.toLocaleString("ru-RU")},${cents} ${c}`;
};
